import requirementsRoutes from 'modules/requirements/common/routing/routes'

const routes = {
  root: requirementsRoutes.root,
  group: `${requirementsRoutes.root}/group`,
}

export default routes
